var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountBalanceWallet = function SvgAccountBalanceWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M874.667 213.333v97.28c25.173 14.933 42.667 41.813 42.667 73.387v256c0 31.573-17.493 58.453-42.667 73.387v97.28c0 46.933-38.4 85.333-85.333 85.333H192.001c-47.36 0-85.333-38.4-85.333-85.333V213.334c0-46.933 37.973-85.333 85.333-85.333h597.333c46.933 0 85.333 38.4 85.333 85.333zM533.333 640H832V384H533.333zM192 213.333v597.333h597.333v-85.333h-256C486.4 725.333 448 686.933 448 640V384c0-46.933 38.4-85.333 85.333-85.333h256v-85.333H192zM725.333 512c0 35.345-28.655 64-64 64s-64-28.655-64-64 28.655-64 64-64 64 28.655 64 64"
  })));
};
export default SvgAccountBalanceWallet;